import { render, staticRenderFns } from "./BrigadeMapCurrentTasks.vue?vue&type=template&id=32833ee5&scoped=true&"
import script from "./BrigadeMapCurrentTasks.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapCurrentTasks.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeMapCurrentTasks.vue?vue&type=style&index=0&id=32833ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32833ee5",
  null
  
)

export default component.exports
import {QBtn,QTooltip,QIcon,QSeparator,QBanner,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QIcon,QSeparator,QBanner,QInnerLoading,QSpinnerGears}, component.options.components || {})
